import { ThemeOptions } from '@mui/material';
import type {} from '@mui/x-date-pickers-pro/themeAugmentation';
import { capitalDesignTokens } from '../../capital_design_tokens';

export const MuiDateCalendar: ThemeOptions['components']['MuiDateCalendar'] = {
  defaultProps: {
    slotProps: {},
    views: ['month', 'year', 'day'],
    fixedWeekNumber: 6,
    showDaysOutsideCurrentMonth: true,
    yearsPerRow: 3
  },
  styleOverrides: {
    root: ({ theme, ownerState }) => ({
      height: 364,
      maxHeight: 364,
      // Calendar Header Styles
      '& .MuiPickersCalendarHeader-root': {
        color: theme.palette.text.secondary,
        button: {
          color: 'inherit'
        },
        '& .MuiPickersCalendarHeader-switchViewButton': {
          '&.Mui-focusVisible, &:focus-visible': {
            outlineOffset: '-2px'
          }
        }
      },

      // Day sizes increased - do not want these on range calendar due to scaling increasing button sizes there already
      '& .MuiPickersDay-root': {
        width: 40,
        height: 40,
        margin: 0
      },

      // Year and Month Calendar Padding
      ...(ownerState.monthsPerRow !== 4 && {
        '& .MuiMonthCalendar-root': {
          paddingLeft: theme.spacing(3),
          paddingRight: theme.spacing(3)
        }
      }),
      ...(ownerState.yearsPerRow !== 4 && {
        '& .MuiYearCalendar-root': {
          paddingLeft: theme.spacing(3),
          paddingRight: theme.spacing(3)
        }
      }),

      // Year and Month Button Styles
      '& .MuiPickersYear-yearButton, .MuiPickersMonth-monthButton': {
        fontSize: capitalDesignTokens.foundations.typography.fontSize.h4,
        fontWeight: capitalDesignTokens.foundations.typography.fontWeight.semiBold,
        '&.Mui-focusVisible, &:focus-visible, &:hover, &:focus': {
          backgroundColor: theme.palette.action.hover
        },
        '&.Mui-selected': {
          color: theme.palette.common.white,
          backgroundColor: theme.palette.primary.main,
          '&:focus, &:hover': {
            backgroundColor: theme.palette.primary.dark
          }
        }
      },

      '& button.Mui-disabled': {
        color: theme.palette.text.disabled,
        opacity: 0.4
      }
    })
  }
};
